export const comparisonTranslations = {
    "fa": {
        "featuresAndSpecs": "ویژگی‌ها و مشخصات",
        "viewSpecs": "مشاهده مشخصات",
        "hardwareAndDesign": "سخت‌افزار و طراحی",
        "sensorsAndHealth": "سنسورها و پایش سلامت",
        "smartCapabilities": "قابلیت‌های هوشمند",
        "otherFeatures": "سایر ویژگی‌ها",
        "viewAllSpecs": "مشاهده تمام مشخصات و ویژگی‌ها",
        "showLess": "نمایش کمتر",
        "selectCategoryHelp": "برای مقایسه رده‌های مختلف، دسته‌بندی مورد نظر را انتخاب کنید",
        "fullProductSpecs": "مشخصات فنی و امکانات کامل محصول",
        "models": "مدل‌ها:",
        "medical": "مدیکال",
        "economic": "اقتصادی",
        "standard": "استاندارد",
        "advanced": "پیشرفته",
        "women": "بانوان",
        "kidwatch": "ساعت کودک",
        "tracker": "ردیاب",
        "all": "همه",
        "allTrackers": "همه ردیاب‌ها",
        "yes": "دارد",
        "active": "فعال",
        "close": "بستن",
        "categories": {
            "all": "همه",
            "medical": "پیشرو",
            "standard": "استاندارد",
            "economic": "اقتصادی",
            "advanced": "پیشرفته",
            "women": "بانوان",
            "kidwatch": "ساعت کودک",
            "tracker": "ردیاب",
            "screenless-band": "دستبند بدون نمایشگر",
            "fitness-band": "دستبند ورزشی",
            "smartband": "دستبند هوشمند"
        },
        "features": {
            "وزن": "وزن",
            "جنس بدنه": "جنس بدنه",
            "رنگ‌بندی": "رنگ‌بندی",
            "گواهی ضد آب": "گواهی ضد آب",
            "درجه دقت حسگرها": "درجه دقت حسگرها",
            "عمر باتری": "عمر باتری",
            "شارژ بی‌سیم": "شارژ بی‌سیم",
            "پایش سلامت پیوسته و ۲۴ ساعته": "پایش سلامت پیوسته و ۲۴ ساعته",
            "ضربان قلب": "ضربان قلب",
            "تغییرات HRV": "تغییرات HRV",
            "سطح اکسیژن خون (SpO2)": "سطح اکسیژن خون (SpO2)",
            "ECG (نوار قلب)": "ECG (نوار قلب)",
            "VO2max": "VO2max",
            "روند انرژی و متابولیسم": "روند انرژی و متابولیسم",
            "پایش خواب": "پایش خواب",
            "نرخ تنفس": "نرخ تنفس",
            "دمای پوست": "دمای پوست",
            "دمای بدن": "دمای بدن",
            "قدم‌شمار": "قدم‌شمار",
            "حالت ورزشی": "حالت ورزشی",
            "تعداد حالت‌های ورزشی": "تعداد حالت‌های ورزشی",
            "سطح استرس": "سطح استرس",
            "ژست‌های حرکتی": "ژست‌های حرکتی",
            "تماس اضطراری": "تماس اضطراری",
            "API توسعه‌دهنده": "API توسعه‌دهنده",
            "اشتراک‌گذاری سلامت با خانواده و اعضا": "اشتراک‌گذاری سلامت با خانواده و اعضا",
            "جنس بند": "جنس بند",
            "نمایشگر": "نمایشگر",
            "ظرفیت باتری (mAh)": "ظرفیت باتری (mAh)",
            "زمان آماده‌باش": "زمان آماده‌باش",
            "نوع شارژ": "نوع شارژ",
            "بلوتوث": "بلوتوث",
            "به‌روزرسانی OTA": "به‌روزرسانی OTA",
            "NFC": "NFC",
            "بانوان": "بانوان",
            "مود ورزشی": "مود ورزشی",
            "ردیابی موقعیت": "ردیابی موقعیت",
            "پایش گردش خون": "پایش گردش خون",
            "ارتباط سلولی (Comm.)": "ارتباط سلولی",
            "GPS": "GPS",
            "حافظه": "حافظه رم",
            "دیسک": "حافظه داخلی",
            "اندازه نمایشگر": "اندازه نمایشگر",
            "جنس نمایشگر": "جنس نمایشگر",
            "دوربین": "دوربین",
            "تعداد هسته‌های پردازنده": "پردازنده",
            "قابلیت تماس صوتی": "تماس صوتی",
            "دکمه اضطراری (SoS Button)": "دکمه اضطراری SOS"
        },
        "featureDescriptions": {},
        "featureValues": {
            "استیل": "استیل",
            "استیل ضد زنگ": "استیل ضد زنگ",
            "استیل ضدزنگ": "استیل ضد زنگ",
            "تیتانیوم": "تیتانیوم",
            "آلیاژ فلز با گرید پزشکی": "آلیاژ فلز با گرید پزشکی",
            "آلیاژ تیتانیوم": "آلیاژ تیتانیوم",
            "پلاستیک": "پلاستیک",
            "سرامیک": "سرامیک",
            "آلومینیوم": "آلومینیوم",
            "فولاد سبک": "فولاد سبک",
            "مشکی": "مشکی",
            "نقره‌ای": "نقره‌ای",
            "نقره ای": "نقره‌ای",
            "طلایی": "طلایی",
            "رزگلد": "رزگلد",
            "صورتی": "صورتی",
            "آبی": "آبی",
            "خاکستری": "خاکستری",
            "طوسی": "طوسی",
            "سرمه‌ای": "سرمه‌ای",
            "زیتونی": "زیتونی",
            "سبز": "سبز",
            "قرمز": "قرمز",
            "Orange": "نارنجی",
            "Black": "مشکی",
            "Silver": "نقره‌ای",
            "Blue": "آبی",
            "Pink": "صورتی",
            "High": "بالا",
            "Ordinary": "معمولی",
            "No": "ندارد",
            "خیلی بالا": "خیلی بالا",
            "بسیار بالا": "بسیار بالا",
            "سطح پزشکی (Medical-Grade)": "سطح پزشکی (Medical-Grade)",
            "نامشخص (احتمالاً استاندارد)": "نامشخص (احتمالاً استاندارد)",
            "نامشخص": "نامشخص",
            "استاندارد": "استاندارد",
            "معمولی": "معمولی",
            "پایین": "پایین",
            "ساده": "ساده",
            "6 گرم": "۶ گرم",
            "گرم 6": "۶ گرم",
            "5 گرم": "۵ گرم",
            "گرم 5": "۵ گرم",
            "4 گرم": "۴ گرم",
            "7 گرم": "۷ گرم",
            "8 گرم": "۸ گرم",
            "5.5 گرم": "۵٫۵ گرم",
            "36 گرم": "۳۶ گرم",
            "40 گرم": "۴۰ گرم",
            "42 گرم": "۴۲ گرم",
            "55 گرم": "۵۵ گرم",
            "200 گرم": "۲۰۰ گرم",
            "7 روز": "۷ روز",
            "روز 7": "۷ روز",
            "10 روز": "۱۰ روز",
            "روز 10": "۱۰ روز",
            "3 روز": "۳ روز",
            "4 روز": "۴ روز",
            "5 روز": "۵ روز",
            "6 روز": "۶ روز",
            "9 روز": "۹ روز",
            "3.5 روز": "۳٫۵ روز",
            "4 تا 5 روز": "۴ تا ۵ روز",
            "4 تا 6 روز": "۴ تا ۶ روز",
            "5 تا 7 روز": "۵ تا ۷ روز",
            "7 تا 10 روز": "۷ تا ۱۰ روز"
        }
    },
    "en": {
        "featuresAndSpecs": "Features & Specifications",
        "viewSpecs": "View Specs",
        "hardwareAndDesign": "Hardware & Design",
        "sensorsAndHealth": "Sensors & Health Monitoring",
        "smartCapabilities": "Smart Features",
        "otherFeatures": "Other Features",
        "viewAllSpecs": "View All Specifications & Features",
        "showLess": "Show Less",
        "selectCategoryHelp": "Select a category to compare different series",
        "fullProductSpecs": "Full Technical Specifications & Features",
        "models": "Models:",
        "medical": "Medical Grade",
        "economic": "Essential",
        "standard": "Standard",
        "advanced": "Advanced",
        "women": "Women's",
        "kidwatch": "Kids Watch",
        "tracker": "Tracker",
        "all": "All",
        "allTrackers": "All Trackers",
        "yes": "Yes",
        "active": "Active",
        "close": "Close",
        "categories": {
            "all": "All",
            "medical": "Medical Grade",
            "standard": "Standard",
            "economic": "Essential",
            "advanced": "Advanced",
            "women": "Women's Health",
            "kidwatch": "Kids Watch",
            "tracker": "Tracker",
            "screenless-band": "Screenless Band",
            "fitness-band": "Fitness Band",
            "smartband": "Smart Band"
        },
        "features": {
            "وزن": "Weight",
            "جنس بدنه": "Case Material",
            "رنگ‌بندی": "Color Options",
            "گواهی ضد آب": "Water Resistance",
            "درجه دقت حسگرها": "Sensor Precision",
            "عمر باتری": "Battery Life",
            "شارژ بی‌سیم": "Wireless Charging",
            "پایش سلامت پیوسته و ۲۴ ساعته": "24/7 Continuous Health Monitoring",
            "ضربان قلب": "Heart Rate",
            "تغییرات HRV": "HRV Variability",
            "سطح اکسیژن خون (SpO2)": "Blood Oxygen (SpO2)",
            "ECG (نوار قلب)": "ECG",
            "VO2max": "VO2max",
            "روند انرژی و متابولیسم": "Energy & Metabolism Trend",
            "پایش خواب": "Sleep Tracking",
            "نرخ تنفس": "Respiration Rate",
            "دمای پوست": "Skin Temperature",
            "دمای بدن": "Body Temperature",
            "قدم‌شمار": "Step Counter",
            "حالت ورزشی": "Sports Mode",
            "تعداد حالت‌های ورزشی": "Sports Modes Count",
            "سطح استرس": "Stress Level",
            "ژست‌های حرکتی": "Gesture Controls",
            "تماس اضطراری": "Emergency SOS",
            "API توسعه‌دهنده": "Developer API",
            "اشتراک‌گذاری سلامت با خانواده و اعضا": "Family Health Sharing",
            "جنس بند": "Strap Material",
            "نمایشگر": "Display",
            "ظرفیت باتری (mAh)": "Battery Capacity",
            "زمان آماده‌باش": "Standby Time",
            "نوع شارژ": "Charging Type",
            "بلوتوث": "Bluetooth",
            "به‌روزرسانی OTA": "OTA Updates",
            "NFC": "NFC",
            "بانوان": "Women's Health",
            "مود ورزشی": "Workout Mode",
            "ردیابی موقعیت": "GPS / Location Tracking",
            "پایش گردش خون": "Circulation Monitoring",
            "ارتباط سلولی (Comm.)": "Cellular Connectivity",
            "GPS": "GPS",
            "حافظه": "RAM Memory",
            "دیسک": "Internal Storage",
            "اندازه نمایشگر": "Display Size",
            "جنس نمایشگر": "Display Tech",
            "دوربین": "Camera",
            "تعداد هسته‌های پردازنده": "Processor Cores",
            "قابلیت تماس صوتی": "Voice Calling",
            "دکمه اضطراری (SoS Button)": "SOS Button"
        },
        "featureDescriptions": {
            "وزن دستگاه برای استفاده روزانه": "Device weight for daily use",
            "متریال ضدحساسیت و مقاوم": "Hypoallergenic and durable materials",
            "رنگ‌های متنوع و قابل انتخاب": "Multiple color options available",
            "مناسب برای شستشو یا باران": "Suitable for washing and rain",
            "میزان دقت در پایش سلامت": "Precision level in health monitoring",
            "مدت زمان نگهداری شارژ": "Battery runtime duration",
            "مدت زمان نگهداری شارژ در استفاده عادی": "Battery life during normal use",
            "شارژ بدون نیاز به کابل": "Cable-free charging capability",
            "رصد دائمی علائم حیاتی در طول شبانه‌روز": "Continuous 24/7 vital sign tracking",
            "پایش مداوم سلامت قلب": "Continuous heart rate monitoring",
            "تحلیل استرس و ریکاوری": "Stress and recovery analysis",
            "بررسی سطح اکسیژن در خون": "Blood oxygen level monitoring",
            "تشخیص بی‌نظمی‌های قلب": "Cardiac arrhythmia detection",
            "سنجش توان هوازی بدن": "Aerobic capacity assessment",
            "پشتیبانی از پایش گلوکز": "Glucose risk monitoring support",
            "تحلیل کیفیت خواب شبانه": "Nighttime sleep quality analysis",
            "تعداد تنفس در دقیقه": "Breaths per minute tracking",
            "پایش تب و تغییرات دما": "Fever and skin temperature tracking",
            "شمارش قدم‌های روزانه": "Daily step counting",
            "پایش فعالیت‌های ورزشی و تناسب اندام": "Sports and fitness activity tracking",
            "ارزیابی تنش روزانه": "Daily stress level evaluation",
            "کنترل با ضربه یا حرکت دست": "Tap and gesture control",
            "ارسال هشدار در شرایط خطر": "Emergency SOS alert dispatch",
            "دسترسی به داده برای برنامه‌نویس": "Developer API access",
            "امکان ارسال وضعیت سلامت به عزیزان": "Family health data sharing",
            "ظرفیت باتری به میلی‌آمپر ساعت برای مدت زمان استفاده مداوم": "Battery capacity in mAh",
            "مدت زمان نگهداری شارژ در حالت آماده‌باش": "Standby battery duration",
            "روش اتصال شارژر به دستگاه": "Charger connection type",
            "استاندارد مقاومت در برابر نفوذ آب": "Water resistance rating",
            "نوع متریال بند دستگاه": "Strap material type",
            "نوع و اندازه صفحه نمایش": "Display type and size",
            "بررسی تغییرات زمانی بین ضربان‌های قلب": "Heart rate variability tracking",
            "پایش و ارزیابی غیرتهاجمی روند انرژی": "Non-invasive energy trend tracking",
            "پایش چرخه قاعدگی، تخمک‌گذاری و سلامت بانوان": "Menstrual cycle and ovulation tracking",
            "پایش گردش خون": "Circulation tracking",
            "شمار انواع فعالیت‌های ورزشی قابل پایش": "Number of trackable sports modes",
            "سطح دقت سنسورهای پایش سلامت برای اندازه‌گیری دقیق‌تر داده‌ها": "Health sensor accuracy level",
            "مکان‌یابی دقیق با استفاده از سیستم موقعیت‌یاب جهانی": "Accurate GPS positioning",
            "دارای استاندارد مقاومت در برابر نفوذ آب برای استفاده در شرایط مرطوب": "Water resistant standard for wet environments",
            "حجم حافظه داخلی برای ذخیره‌سازی اطلاعات و داده‌ها": "Internal storage capacity",
            "واحد ذخیره‌سازی قابل ارتقاء یا تعویض داخل دستگاه": "Storage drive module",
            "قطر یا سطح نمایشگر برای مشاهده راحت‌تر اطلاعات": "Display size and diagonal",
            "نوع متریال به کار رفته در صفحه نمایش برای مقاومت و وضوح بهتر": "Screen panel technology",
            "مشخصات و رزولوشن دوربین برای ثبت تصاویر و تماس‌های ویدیویی": "Camera specifications and resolution",
            "شماره هسته‌های پردازشی برای عملکرد سریع‌تر و روان‌تر": "Processor core count",
            "پایش لحظه‌ای میزان ضربان قلب و نمایش روند سلامت قلب": "Real-time heart rate monitoring",
            "انتخاب بین رنگ‌های مختلف بدنه برای سلیقه‌های گوناگون": "Body color selection",
            "پشتیبانی از شبکه‌های ارتباطی مانند 4G برای اتصال و ارتباط بی‌وقفه": "Cellular network support (4G)",
            "مکان‌یابی لحظه‌ای با دقت بالا برای ردیابی موقعیت": "High precision real-time tracking",
            "استاندارد مقاومت در برابر نفوذ آب برای استفاده ایمن در شرایط مرطوب": "Waterproof standard for safe wet use",
            "میزان ظرفیت باتری برای تعیین طول عمر شارژ و دوام استفاده": "Battery capacity for usage duration",
            "وزن دستگاه برای راحتی در پوشیدن مداوم بدون احساس سنگینی": "Device weight for comfortable wear",
            "امکان برقراری تماس صوتی میان دستگاه و سرپرست برای برقراری ارتباط فوری": "Voice calling functionality",
            "ارسال سیگنال هشدار به مخاطب‌های از پیش تعریف‌شده در مواقع اضطراری": "SOS emergency warning button",
            "امکان ثبت تصویر و تماس ویدئویی برای بررسی تصویری محیط یا کودک": "Photo & video call capabilities",
            "تنوع رنگ‌های قابل انتخاب برای سلیقه‌ها و اولویت‌های مختلف": "Color choices and preferences"
        },
        "featureValues": {
            "127": "127",
            "فوق‌العاده سبک حدود ۲ تا ۳ گرم (ضخامت 2.2mm، پهنا 8.0mm)": "Ultra-light ~2-3g (Thickness 2.2mm, Width 8.0mm)",
            "فوق‌العاده باریک (ضخامت 2.2mm، پهنا 8.0mm)": "Ultra-thin (Thickness 2.2mm, Width 8.0mm)",
            "فوق‌العاده سبک و ارگونومیک (پهنا 8.0 میلی‌متر)": "Ultra-light & ergonomic (Width 8.0mm)",
            "سبک و مقاوم": "Lightweight & durable",
            "طراحی ارگونومیک": "Ergonomic design",
            "آلیاژ تیتانیوم مقاوم درجه یک (Titanium)": "Premium Titanium Alloy",
            "استیل ضد زنگ ۳۱۶L": "316L Stainless Steel",
            "سرامیک پیشرفته زیرکونیا / تیتانیوم (Ceramic/Titanium)": "Advanced Zirconia Ceramic / Titanium",
            "رزگلد، نقره‌ای، مشکی، طلایی": "Rose Gold, Silver, Black, Gold",
            "مشکی براق سرامیکی، نقره‌ای، طلایی": "Glossy Ceramic Black, Silver, Gold",
            "مشکی، نقره‌ای، خاکستری، طلایی": "Black, Silver, Grey, Gold",
            "مشکی، نقره‌ای، طلایی": "Black, Silver, Gold",
            "5ATM (مقاوم تا عمق ۵۰ متری - مناسب شنا و استفاده روزمره)": "5ATM (Waterproof up to 50m - Swimming & Daily)",
            "IP68 / 5ATM (مقاوم در برابر آب و گرد و غبار)": "IP68 / 5ATM (Water & Dust Resistant)",
            "بسیار بالا مجهز به سنسور حرارتی تخصصی دمای پایه بدن (BBT) و ماژول اپتیکال PPG": "Very High (Specialized BBT Thermal & PPG Optical Module)",
            "بالا (سنسور PPG اپتیکال نسل جدید)": "High (Next-Gen PPG Optical Sensor)",
            "استاندارد و دقیق": "Standard & Accurate",
            "7 تا 10 روز (شارژ سریع در کمتر از ۲ ساعت)": "7-10 Days (Fast Charging < 2 hrs)",
            "5 تا 7 روز": "5-7 Days",
            "3 تا 5 روز": "3-5 Days",
            "پایش مداوم و شبانه‌روزی اکسیژن خون (SpO2)": "Continuous 24/7 Blood Oxygen (SpO2) Monitoring",
            "ارزیابی غیرتهاجمی روند انرژی": "Non-Invasive Energy Trend",
            "پایش تخصصی فازهای خواب (Light/Deep/REM)، نمره خواب، Fuel Score و کیفیت استراحت": "Specialized Sleep Phases (Light/Deep/REM), Sleep Score & Fuel Score",
            "پایش پیوسته دمای پوست و دمای پایه بدن در خواب (BBT Tracking)": "Continuous Skin Temp & Overnight BBT Tracking",
            "پایش ۲۴ ساعته سطح استرس، شاخص VitalAge و آمادگی ریکاوری": "24/7 Stress Tracking, VitalAge Index & Recovery Readiness",
            "تخصصی و پیشرفته (پایش دمای شبانه BBT، پیش‌بینی دقیق چرخه قاعدگی، زمان تخمک‌گذاری و بارداری)": "Advanced Women's Health (Night BBT, Cycle & Ovulation Prediction)",
            "پایش فعالیت روزانه، کالری مصرفی، مسافت و مودهای ورزشی چندگانه": "Daily Activity, Calories, Distance & Multi-Sport Tracking",
            "3 تا 5 روز استفاده مداوم": "3-5 Days Continuous Use",
            "5 تا 7 روز استفاده مداوم": "5-7 Days Continuous Use",
            "7 تا 10 روز استفاده مداوم": "7-10 Days Continuous Use",
            "10 تا 15 روز": "10-15 Days",
            "15 تا 20 روز": "15-20 Days",
            "شارژ مغناطیسی اختصاصی": "Dedicated Magnetic Charger",
            "شارژر مگنتی": "Magnetic Charger",
            "IP67 (مقاوم در برابر پاشش آب)": "IP67 (Splashproof)",
            "IP68 (مقاوم تا عمق ۱.۵ متری)": "IP68 (Up to 1.5m Depth)",
            "آلیاژ روی + پلاستیک فشرده": "Zinc Alloy + ABS Plastic",
            "سیلیکون طبّی ضد حساسیت": "Medical Grade Anti-Allergic Silicone",
            "سیلیکون نرم باکیفیت": "Soft High-Quality Silicone",
            "0.96 اینچ TFT": "0.96\" TFT",
            "1.47 اینچ AMOLED": "1.47\" AMOLED",
            "1.1 اینچ OLED": "1.1\" OLED",
            "پایش عمومی خواب": "General Sleep Tracking",
            "پایش پیشرفته فازهای خواب": "Advanced Sleep Phase Tracking",
            "پایش ۲۴ ساعته با هشدار": "24/7 Monitoring with Alerts",
            "پایش دوره‌ای": "Periodic Monitoring",
            "ارزیابی غیرتهاجمی": "Non-invasive Assessment",
            "پایش بنیادی چرخه": "Basic Cycle Tracking",
            "پایش کامل با پیش‌بینی": "Full Cycle Tracking & Prediction",
            "هشدار افزایش استرس": "High Stress Alert",
            "تخمین پیوسته": "Continuous Estimation",
            "8 حالت ورزشی": "8 Sports Modes",
            "15 حالت ورزشی": "15 Sports Modes",
            "100+ حالت ورزشی": "100+ Sports Modes",
            "مشکی، سرمه‌ای، صورتی": "Black, Navy, Pink",
            "مشکی، نقره‌ای، رزگلد": "Black, Silver, Rose Gold",
            "بسیار بالا": "Very High",
            "بالا": "High",
            "متوسط": "Medium",
            "55 گرم": "55g",
            "45 گرم": "45g",
            "1.4 اینچ HD": "1.4\" HD",
            "1.3 اینچ IPS": "1.3\" IPS",
            "2 مگاپیکسل": "2 MP",
            "0.3 مگاپیکسل": "0.3 MP",
            "4 هسته‌ای": "Quad-Core",
            "دو هسته‌ای": "Dual-Core",
            "صورتی، آبی، مشکی": "Pink, Blue, Black",
            "آبی، قرمز": "Blue, Red",
            "استیل": "Steel",
            "استیل ضد زنگ": "Stainless Steel",
            "استیل ضدزنگ": "Stainless Steel",
            "تیتانیوم": "Titanium",
            "آلیاژ فلز با گرید ممتاز": "Premium Metal Alloy",
            "آلیاژ تیتانیوم": "Titanium Alloy",
            "آلیاژ تیتانیوم درجه هوافضا (Titanium)": "Aerospace Titanium Alloy",
            "آلیاژ تیتانیوم مقاوم و سبک (Titanium)": "Lightweight Titanium Alloy",
            "پلاستیک": "Plastic",
            "سرامیک": "Ceramic",
            "آلومینیوم": "Aluminum",
            "فولاد سبک": "Lightweight Steel",
            "استیل ضدزنگ (PVD)": "Stainless Steel (PVD)",
            "استیل ضدزنگ (Stainless Steel)": "Stainless Steel",
            "پلی‌کربنات (PC) ": "Polycarbonate (PC)",
            "پلی‌کربنات مقاوم و آلیاژ سبک (PC+ABS)": "Durable Polycarbonate & Light Alloy (PC+ABS)",
            "آلیاژ روی و پلی‌کربنات فشرده (Zinc Alloy + PC)": "Zinc Alloy + Polycarbonate (PC)",
            "بافت فلزی کلاسیک": "Classic Metallic Texture",
            "مشکی براق (Full-light black)": "Glossy Black",
            "مشکی": "Black",
            "نقره‌ای": "Silver",
            "نقره ای": "Silver",
            "طلایی": "Gold",
            "رزگلد": "Rose Gold",
            "صورتی": "Pink",
            "آبی": "Blue",
            "خاکستری": "Grey",
            "طوسی": "Grey",
            "سرمه‌ای": "Navy",
            "زیتونی": "Olive",
            "سبز": "Green",
            "قرمز": "Red",
            "آبی نفتی": "Petrol Blue",
            "مشکی (استاندارد)": "Black (Standard)",
            "ساده": "Basic",
            "خیلی بالا": "Very High",
            "گرید ممتاز": "Premium Grade",
            "بالا (تراشه‌های Goodix 3228T و Nordic)": "High (Goodix & Nordic Chips)",
            "بالا (دقت و پایش هوشمند)": "High (Smart Precision)",
            "بسیار بالا (تخصصی بانوان)": "Very High (Women's Special)",
            "سطح ممتاز (سنسور ترانسمیسیون SpO2 با دقت ±2.7%)": "Premium Grade (SpO2 ±2.7%)",
            "بسیار بالا و بهینه‌شده برای پایش خواب (ماژول مادون‌قرمز PPG)": "Very High (PPG Infrared Sleep)",
            "بالا همراه با حسگر کنترل لمسی هوشمند (Smart Touch)": "High with Smart Touch Control",
            "معمولی": "Standard",
            "استاندارد": "Standard",
            "پایین": "Basic",
            "دقت بالا مجهز به الکترودهای ECG و سنسور اپتیکال دوگانه PPG": "High Precision (ECG Electrodes & Dual PPG Sensor)",
            "پیشرفته با الگوریتم‌های هوش مصنوعی ریکاوری و سنسورهای چندگانه": "Advanced AI Recovery Algorithms & Multi-Sensors",
            "پیشرفته با هوش مصنوعی و سنسورهای اپتیکال چندگانه": "Advanced AI & Multiple Optical Sensors",
            "بالا (تراشه ECG با فرکانس 512Hz)": "High (512Hz ECG Chip)",
            "نامشخص (احتمالاً استاندارد)": "Unspecified (Standard)",
            "نامشخص": "Unspecified",
            "6 گرم": "6g",
            "گرم 6": "6g",
            "5 گرم": "5g",
            "گرم 5": "5g",
            "4 گرم": "4g",
            "7 گرم": "7g",
            "8 گرم": "8g",
            "5.5 گرم": "5.5g",
            "36 گرم": "36g",
            "40 گرم": "40g",
            "42 گرم": "42g",
            "200 گرم": "200g",
            "3.4g": "3.4g",
            "4.2g": "4.2g",
            "2.5g": "2.5g",
            "3.1g": "3.1g",
            "4.5g": "4.5g",
            "8g": "8g",
            "2 - 3g": "2-3g",
            "3.6 - 4.2g": "3.6-4.2g",
            "3.4g (فوق‌العاده سبک، ضخامت 2.7mm)": "3.4g (Ultra-light, 2.7mm)",
            "5ATM": "5ATM",
            "3ATM": "3ATM",
            "IP68": "IP68",
            "IP67": "IP67",
            "IP66": "IP66",
            "IP65": "IP65",
            "IPX7": "IPX7",
            "IPX6": "IPX6",
            "5ATM (مناسب شنا و استفاده روزمره)": "5ATM (Swimming & Daily)",
            "5ATM (مناسب شنا و فعالیت‌های آبی)": "5ATM (Swimming & Water Sports)",
            "5ATM (مناسب شنا و ورزش‌های آبی)": "5ATM (Swimming & Water Sports)",
            "3ATM (مقاوم تا عمق ۳۰ متری)": "3ATM (30m Waterproof)",
            "IP68 (مقاوم در برابر آب، تعریق و فعالیت‌های روزانه)": "IP68 (Water, Sweat & Daily Activities Resistant)",
            "IP68 (مقاوم در برابر آب و غوطه‌وری)": "IP68 (Submersible Waterproof)",
            "7 روز": "7 Days",
            "روز 7": "7 Days",
            "10 روز": "10 Days",
            "روز 10": "10 Days",
            "3 روز": "3 Days",
            "4 روز": "4 Days",
            "5 روز": "5 Days",
            "6 روز": "6 Days",
            "9 روز": "9 Days",
            "3.5 روز": "3.5 Days",
            "4 تا 5 روز": "4-5 Days",
            "4 تا 6 روز": "4-6 Days",
            "7 تا 10 روز": "7-10 Days",
            "5 تا 10 روز (شارژ بی‌سیم سریع)": "5-10 Days (Fast Wireless)",
            "5 تا 7 روز (پایش مداوم هفتگی بدون وقفه)": "5-7 Days Continuous",
            "7+ روز (شارژ بی‌سیم سریع کمتر از ۹۰ دقیقه)": "7+ Days (Fast Charge <90m)",
            "7 تا 14 روز (شارژدهی طولانی به دلیل حذف نمایشگر)": "7-14 Days (Extended Battery - Screenless)",
            "25+ روز": "25+ Days",
            "30+ روز": "30+ Days",
            "20+ روز": "20+ Days",
            "7+ روز": "7+ Days",
            "فوق‌العاده سبک و کم‌حجم (طراحی ارگونومیک بدون صفحه نمایش)": "Ultra-light & Compact (Screenless Ergonomic Design)",
            "پارچه‌ای بافت‌دار تنفسی (Woven) / سیلیکونی ضدحساسیت": "Breathable Woven Fabric / Anti-Allergic Silicone",
            "مشکی، طوسی، سرمه‌ای و رنگ‌های متنوع": "Black, Grey, Navy & Various Colors",
            "130 mAh (لیتیوم پلیمری کم‌مصرف)": "130 mAh Low-power Li-Po",
            "مگنتیک مغناطیسی (Magnetic Fast Charge)": "Magnetic Fast Charge",
            "بدون نمایشگر (Faceless / Screenless با نشانگر وضعیت LED)": "Screenless (LED Status Indicator)",
            "BLE 5.0": "BLE 5.0",
            "پایش خودکار و پیشرفته مراحل خواب، کیفیت استراحت و الگوی تنفس": "Auto & Advanced Sleep Phases, Quality & Breathing",
            "پایش ۲۴ ساعته سطح استرس و تحلیل تعادل عصبی با HRV": "24/7 Stress Level & HRV Neural Balance Analysis",
            "پشتیبانی کامل (پایش چرخه قاعدگی و سلامت بانوان)": "Full Support (Cycle Tracking & Women's Health)",
            "مودهای چندگانه ورزشی (Multi-Sport)، سنجش کالری و مسافت": "Multi-Sport Modes, Calories & Distance",
            "فوق‌العاده سبک و ارگونومیک (ابعاد 42×22×9.5 میلی‌متر)": "Ultra-light & Ergonomic (42×22×9.5mm)",
            "بافت‌دار کشسان و تنفسی (Woven) / نایلونی ضدحساسیت": "Elastic Woven / Anti-Allergic Nylon",
            "مشکی، زیتونی، رنگ‌های متنوع و جذاب": "Black, Olive & Vibrant Colors",
            "95 mAh (لیتیوم پلیمری کم‌مصرف)": "95 mAh Low-power Li-Po",
            "مگنتیک فست‌شارژ (Magnetic Fast Charge)": "Magnetic Fast Charge",
            "بدون نمایشگر (Screenless - تمرکز کامل بر ریکاوری بدون حواس‌پرتی)": "Screenless (Recovery Focused, Distraction-Free)",
            "BLE 5.0 (برد تا ۱۰ متر)": "BLE 5.0 (Up to 10m Range)",
            "پایش پیشرفته فازهای خواب (REM/عمیق/سبک)، الگوی تنفس و نمره خواب": "Advanced Sleep Phases (REM/Deep/Light), Breathing & Sleep Score",
            "ارزیابی استرس و پایش حالات روحی مبتنی بر هوش مصنوعی (AI Mood)": "AI Mood & Stress Assessment",
            "پشتیبانی کامل (پایش چرخه قاعدگی و پیش‌بینی تخمک‌گذاری)": "Full Support (Cycle & Ovulation Prediction)",
            "پایش بار تمرینی (Strain)، ریکاوری هوشمند و مربی هوش مصنوعی": "Strain Tracking, Smart Recovery & AI Coach",
            "فوق‌العاده سبک (ابعاد 25.5×9.3×4.35 میلی‌متر)": "Ultra-light (25.5×9.3×4.35mm)",
            "بافت‌دار تنفسی (Woven) / سیلیکونی ضدحساسیت": "Breathable Woven / Anti-Allergic Silicone",
            "مشکی، نقره‌ای، رنگ‌های متنوع": "Black, Silver & Various Colors",
            "23 mAh (بهینه‌سازی شده با مصرف فوق‌العاده کم)": "23 mAh Ultra-low Consumption",
            "مگنتیک فست‌شارژ (کمتر از ۱.۵ ساعت)": "Magnetic Fast Charge (< 1.5 hrs)",
            "بدون نمایشگر (طراحی مینیمال و ارگونومیک)": "Screenless (Minimalist Ergonomic Design)",
            "ارزیابی غیرتهاجمی روند انرژی و متابولیسم با هوش مصنوعی (BGEM)": "Non-Invasive AI Energy Trend Assessment (BGEM)",
            "پایش پیشرفته فازهای خواب (REM/عمیق) و الگوی تنفس": "Advanced Sleep Phases (REM/Deep) & Breathing",
            "پشتیبانی کامل (پایش چرخه و سلامت بانوان)": "Full Support (Cycle & Women's Health)",
            "پایش ۲۴ ساعته فعالیت، شدت METS و بار ورزشی": "24/7 Activity, METS Intensity & Workout Load",
            "پارچه‌ای (Woven) / سیلیکونی": "Woven Fabric / Silicone",
            "180 mAh": "180 mAh",
            "7 تا 15 روز": "7-15 Days",
            "مگنتیک (Magnetic)": "Magnetic",
            "بدون نمایشگر (LED Indicator)": "Screenless (LED Indicator)",
            "بندهای بافت‌دار (Woven)": "Woven Straps",
            "رنگ‌های متنوع (Vibrant Bands)": "Vibrant Color Bands",
            "بیشتر از 15 روز": "15+ Days",
            "58 mAh + 210 mAh dock": "58 mAh + 210 mAh dock",
            "Magnetic Charging Dock": "Magnetic Charging Dock",
            "ABS+PC": "ABS+PC",
            "Silicone": "Silicone",
            "Vibrant Colors": "Vibrant Colors",
            "حدود ۲۵ گرم": "~25g",
            "بند سیلیکونی": "Silicone Strap",
            "دیجیتالی": "Digital",
            "دارای نمایشگر": "Display Screen",
            "مشکی، آبی، قرمز، سبز": "Black, Blue, Red, Green",
            "معمولی (مناسب پایش روزمره و تناسب اندام)": "Standard (Suitable for Daily Fitness)",
            "۵ تا ۷ روز (باتری 130mAh)": "5-7 Days (130mAh Battery)",
            "100 mAh": "100 mAh",
            "Hospital-grade PPG": "Hospital-Grade PPG",
            "Swimming/Running/Cycling/Yoga": "Swimming / Running / Cycling / Yoga",
            "Multiple Colors": "Multiple Colors",
            "150 mAh": "150 mAh",
            "20-30 روز": "20-30 Days",
            "45-60 روز": "45-60 Days",
            "Silicone/Nylon": "Silicone / Nylon",
            "VC30F-S": "VC30F-S",
            "Multiple": "Multiple",
            "55 mAh": "55 mAh",
            "Zinc Alloy": "Zinc Alloy",
            "Steel/Silicone": "Steel / Silicone",
            "170+": "170+",
            "Magnetic USB": "Magnetic USB",
            "50+": "50+",
            "Black/Blue/Pink": "Black / Blue / Pink"
        }
    },
    "ar": {
        "featuresAndSpecs": "الميزات والمواصفات",
        "viewSpecs": "عرض المواصفات",
        "hardwareAndDesign": "العتاد والتصميم",
        "sensorsAndHealth": "المستشعرات ومراقبة الصحة",
        "smartCapabilities": "الميزات الذكية",
        "otherFeatures": "ميزات أخرى",
        "viewAllSpecs": "عرض جميع المواصفات والميزات",
        "showLess": "عرض أقل",
        "selectCategoryHelp": "اختر فئة لمقارنة السلاسل المختلفة",
        "fullProductSpecs": "المواصفات الفنية والميزات الكاملة",
        "models": "الموديلات:",
        "medical": "درجة طبية",
        "economic": "اقتصادي",
        "standard": "قياسي",
        "advanced": "متقدم",
        "women": "صحة المرأة",
        "kidwatch": "ساعة الأطفال",
        "tracker": "جهاز تتبع",
        "all": "الكل",
        "allTrackers": "جميع أجهزة التتبع",
        "yes": "متوفر",
        "active": "مفعل",
        "close": "إغلاق",
        "categories": {
            "all": "الكل",
            "medical": "الرائد",
            "standard": "قياسي",
            "economic": "اقتصادي",
            "advanced": "متقدم",
            "women": "صحة المرأة",
            "kidwatch": "ساعة الأطفال",
            "tracker": "جهاز تتبع",
            "screenless-band": "سوار بدون شاشة",
            "fitness-band": "سوار رياضي",
            "smartband": "سوار ذكي"
        },
        "features": {
            "وزن": "الوزن",
            "جنس بدنه": "مادة الهيكل",
            "رنگ‌بندی": "الألوان المتوفرة",
            "گواهی ضد آب": "مقاومة الماء",
            "درجه دقت حسگرها": "دقة المستشعرات",
            "عمر باتری": "عمر البطارية",
            "شارژ بی‌سیم": "الشحن اللاسلكي",
            "پایش سلامت پیوسته و ۲۴ ساعته": "مراقبة صحية مستمرة ۲۴/۷",
            "ضربان قلب": "معدل ضربات القلب",
            "تغییرات HRV": "تباين ضربات القلب (HRV)",
            "سطح اکسیژن خون (SpO2)": "نسبة الأكسجين في الدم (SpO2)",
            "ECG (نوار قلب)": "تخطيط القلب (ECG)",
            "VO2max": "أقصى استهلاك أكسجين (VO2max)",
            "روند انرژی و متابولیسم": "متابعة مسار الطاقة والتمثيل الغذائي",
            "پایش خواب": "مراقبة النوم",
            "نرخ تنفس": "معدل التنفس",
            "دمای پوست": "درجة حرارة الجلد",
            "دمای بدن": "درجة حرارة الجسم",
            "قدم‌شمار": "عداد الخطوات",
            "حالت ورزشی": "الوضع الرياضي",
            "تعداد حالت‌های ورزشی": "عدد الأوضاع الرياضية",
            "سطح استرس": "مستوى التوتر",
            "ژست‌های حرکتی": "الإيماءات الحركية",
            "تماس اضطراری": "اتصال الطوارئ SOS",
            "API توسعه‌دهنده": "واجهة برمجة التطبيقات (API)",
            "اشتراک‌گذاری سلامت با خانواده و اعضا": "مشاركة البيانات الصحية",
            "جنس بند": "مادة الحزام",
            "نمایشگر": "الشاشة",
            "ظرفیت باتری (mAh)": "سعة البطارية (mAh)",
            "زمان آماده‌باش": "وقت الانتظار",
            "نوع شارژ": "نوع الشحن",
            "بلوتوث": "البلوتوث",
            "به‌روزرسانی OTA": "تحديثات OTA",
            "NFC": "NFC",
            "بانوان": "صحة المرأة",
            "مود ورزشی": "نمط التمرين",
            "ردیابی موقعیت": "تتبع الموقع GPS",
            "پایش گردش خون": "مراقبة الدورة الدموية",
            "ارتباط سلولی (Comm.)": "الاتصال الخلوي",
            "GPS": "GPS",
            "حافظه": "ذاكرة الرام",
            "دیسک": "التخزين الداخلي",
            "اندازه نمایشگر": "حجم الشاشة",
            "جنس نمایشگر": "تقنية الشاشة",
            "دوربین": "الكاميرا",
            "تعداد هسته‌های پردازنده": "أنوية المعالج",
            "قابلیت تماس صوتی": "المكالمات الصوتية",
            "دکمه اضطراری (SoS Button)": "زر الطوارئ SOS"
        },
        "featureDescriptions": {
            "وزن دستگاه برای استفاده روزانه": "وزن الجهاز للاستخدام اليومي",
            "متریال ضدحساسیت و مقاوم": "مواد مضادة للحساسية ومتينة",
            "رنگ‌های متنوع و قابل انتخاب": "خيارات ألوان متعددة",
            "مناسب برای شستشو یا باران": "مناسب للغسيل والمطر",
            "میزان دقت در پایش سلامت": "مستوى الدقة في المراقبة الصحية",
            "مدت زمان نگهداری شارژ": "مدة تشغيل البطارية",
            "مدت زمان نگهداری شارژ در استفاده عادی": "عمر البطارية في الاستخدام العادي",
            "شارژ بدون نیاز به کابل": "إمكانية الشحن اللاسلكي",
            "رصد دائمی علائم حیاتی در طول شبانه‌روز": "مراقبة العلامات الحيوية ۲۴/۷",
            "پایش مداوم سلامت قلب": "مراقبة مستمرة لمعدل ضربات القلب",
            "تحلیل استرس و ریکاوری": "تحليل التوتر والتعافي",
            "بررسی سطح اکسیژن در خون": "مراقبة مستوى الأكسجين في الدم",
            "تشخیص بی‌نظمی‌های قلب": "كشف عدم انتظام ضربات القلب",
            "سنجش توان هوازی بدن": "تقييم السعة الهوائية للجسم",
            "پشتیبانی از پایش گلوکز": "مراقبة مخاطر السكر في الدم",
            "تحلیل کیفیت خواب شبانه": "تحليل جودة النوم الليلي",
            "تعداد تنفس در دقیقه": "معدل التنفس في الدقيقة",
            "پایش تب و تغییرات دما": "تتبع الحمى ودرجة حرارة الجلد",
            "شمارش قدم‌های روزانه": "حساب الخطوات اليومية",
            "پایش فعالیت‌های ورزشی و تناسب اندام": "مراقبة الأنشطة الرياضية واللياقة",
            "ارزیابی تنش روزانه": "تقييم مستويات التوتر اليومي",
            "کنترل با ضربه یا حرکت دست": "التحكم بالنقر والإيماءات",
            "ارسال هشدار در شرایط خطر": "إرسال تنبيهات الطوارئ SOS",
            "دسترسی به داده برای برنامه‌نویس": "وصول واجهة برمجة التطبيقات",
            "امکان ارسال وضعیت سلامت به عزیزان": "مشاركة البيانات الصحية مع العائلة",
            "ظرفیت باتری به میلی‌آمپر ساعت برای مدت زمان استفاده مداوم": "سعة البطارية بالمللي أمبير",
            "مدت زمان نگهداری شارژ در حالت آماده‌باش": "مدة البطارية في وضع الانتظار",
            "روش اتصال شارژر به دستگاه": "نوع اتصال الشاحن",
            "استاندارد مقاومت در برابر نفوذ آب": "معیار مقاومة الماء",
            "نوع متریال بند دستگاه": "نوع مادة الحزام",
            "نوع و اندازه صفحه نمایش": "نوع وحجم الشاشة",
            "بررسی تغییرات زمانی بین ضربان‌های قلب": "تتبع تباين ضربات القلب",
            "پایش و ارزیابی غیرتهاجمی روند انرژی": "تقييم مسار الطاقة بدون وخز",
            "پایش چرخه قاعدگی، تخمک‌گذاری و سلامت بانوان": "مراقبة الدورة الشهرية والتبييض",
            "پایش گردش خون": "مراقبة الدورة الدموية",
            "شمار انواع فعالیت‌های ورزشی قابل پایش": "عدد الأوضاع الرياضية المدعومة",
            "سطح دقت سنسورهای پایش سلامت برای اندازه‌گیری دقیق‌تر داده‌ها": "دقة مستشعرات الصحة",
            "مکان‌یابی دقیق با استفاده از سیستم موقعیت‌یاب جهانی": "تحديد الموقع بدقة عبر GPS",
            "دارای استاندارد مقاومت در برابر نفوذ آب برای استفاده در شرایط مرطوب": "معيار مقاومة الماء للظروف الرطبة",
            "حجم حافظه داخلی برای ذخیره‌سازی اطلاعات و داده‌ها": "سعة التخزين الداخلية",
            "واحد ذخیره‌سازی قابل ارتقاء یا تعویض داخل دستگاه": "وحدة التخزين",
            "قطر یا سطح نمایشگر برای مشاهده راحت‌تر اطلاعات": "حجم الشاشة ورؤية البيانات",
            "نوع متریال به کار رفته در صفحه نمایش برای مقاومت و وضوح بهتر": "تقنية مادة الشاشة",
            "مشخصات و رزولوشن دوربین برای ثبت تصاویر و تماس‌های ویدیویی": "دقة الكاميرا والمكالمات",
            "شماره هسته‌های پردازشی برای عملکرد سریع‌تر و روان‌تر": "عدد أنوية المعالج",
            "پایش لحظه‌ای میزان ضربان قلب و نمایش روند سلامت قلب": "مراقبة ضربات القلب اللحظية",
            "انتخاب بین رنگ‌های مختلف بدنه برای سلیقه‌های گوناگون": "خيارات ألوان الهيكل",
            "پشتیبانی از شبکه‌های ارتباطی مانند 4G برای اتصال و ارتباط بی‌وقفه": "دعم شبكات الاتصال 4G",
            "مکان‌یابی لحظه‌ای با دقت بالا برای ردیابی موقعیت": "تتبع الموقع اللحظي عالي الدقة",
            "استاندارد مقاومت در برابر نفوذ آب برای استفاده ایمن در شرایط مرطوب": "معيار مقاومة الماء للاستخدام الآمن",
            "میزان ظرفیت باتری برای تعیین طول عمر شارژ و دوام استفاده": "سعة البطارية ودوام الاستخدام",
            "وزن دستگاه برای راحتی در پوشیدن مداوم بدون احساس سنگینی": "وزن الجهاز لارتداء مريح",
            "امکان برقراری تماس صوتی میان دستگاه و سرپرست برای برقراری ارتباط فوری": "إمكانية المكالمات الصوتية",
            "ارسال سیگنال هشدار به مخاطب‌های از پیش تعریف‌شده در مواقع اضطراری": "زر SOS لإرسال إنذار الطوارئ",
            "امکان ثبت تصویر و تماس ویدئویی برای بررسی تصویری محیط یا کودک": "التقاط الصور والمكالمات المرئية",
            "تنوع رنگ‌های قابل انتخاب برای سلیقه‌ها و اولویت‌های مختلف": "تنوع الألوان المتوفرة"
        },
        "featureValues": {
            "127": "١٢٧",
            "فوق‌العاده سبک حدود ۲ تا ۳ گرم (ضخامت 2.2mm، پهنا 8.0mm)": "خفيف للغاية ۲-۳ جرام (سمك ۲.۲ مم، عرض ۸.۰ مم)",
            "فوق‌العاده باریک (ضخامت 2.2mm، پهنا 8.0mm)": "رفيع للغاية (سمك ۲.۲ مم، عرض ۸.۰ مم)",
            "فوق‌العاده سبک و ارگونومیک (پهنا 8.0 میلی‌متر)": "خفيف ومريح للغاية (عرض ۸.۰ مم)",
            "سبک و مقاوم": "خفيف ومقاوم",
            "طراحی ارگونومیک": "تصميم مريح",
            "آلیاژ تیتانیوم مقاوم درجه یک (Titanium)": "سبائك التيتانيوم الدرجة الأولى",
            "استیل ضد زنگ ۳۱۶L": "فولاذ مقاوم للصدأ 316L",
            "سرامیک پیشرفته زیرکونیا / تیتانیوم (Ceramic/Titanium)": "سيراميك الزيركونيا المتقدم / تيتانيوم",
            "رزگلد، نقره‌ای، مشکی، طلایی": "ذهب وردي، فضي، أسود، ذهبي",
            "مشکی براق سرامیکی، نقره‌ای، طلایی": "أسود سيراميك لامع، فضي، ذهبي",
            "مشکی، نقره‌ای، خاکستری، طلایی": "أسود، فضي، رمادي، ذهبي",
            "مشکی، نقره‌ای، طلایی": "أسود، فضي، ذهبي",
            "5ATM (مقاوم تا عمق ۵۰ متری - مناسب شنا و استفاده روزمره)": "5ATM (مقاوم حتى ٥٠ متراً - للسباحة)",
            "IP68 / 5ATM (مقاوم در برابر آب و گرد و غبار)": "IP68 / 5ATM (مقاوم للماء والغبار)",
            "بسیار بالا مجهز به سنسور حرارتی تخصصی دمای پایه بدن (BBT) و ماژول اپتیکال PPG": "عالية جداً (سنسور حراري BBT ووحدة PPG)",
            "بالا (سنسور PPG اپتیکال نسل جدید)": "عالية (سنسور PPG البصري الجيل الجديد)",
            "استاندارد و دقیق": "قياسي ودقيق",
            "7 تا 10 روز (شارژ سریع در کمتر از ۲ ساعت)": "٧ إلى ١٠ أيام (شحن سريع خلال أقل من ساعتين)",
            "5 تا 7 روز": "٥ إلى ٧ أيام",
            "3 تا 5 روز": "٣ إلى ٥ أيام",
            "پایش مداوم و شبانه‌روزی اکسیژن خون (SpO2)": "مراقبة مستمرة لأكسجين الدم ۲۴/۷",
            "ارزیابی غیرتهاجمی روند انرژی": "تقييم مؤشر مسار الطاقة بدون وخز",
            "پایش تخصصی فازهای خواب (Light/Deep/REM)، نمره خواب، Fuel Score و کیفیت استراحت": "مراقبة متخصصة لمراحل النوم ونتيجة النوم",
            "پایش پیوسته دمای پوست و دمای پایه بدن در خواب (BBT Tracking)": "مراقبة مستمرة لدرجة حرارة الجلد وBBT",
            "پایش ۲۴ ساعته سطح استرس، شاخص VitalAge و آمادگی ریکاوری": "مراقبة التوتر على مدار ۲۴ ساعة ومؤشر VitalAge",
            "تخصصی و پیشرفته (پایش دمای شبانه BBT، پیش‌بینی دقیق چرخه قاعدگی، زمان تخمک‌گذاری و بارداری)": "صحة المرأة المتخصصة (تتبع BBT والدورة الشهرية)",
            "پایش فعالیت روزانه، کالری مصرفی، مسافت و مودهای ورزشی چندگانه": "مراقبة النشاط اليومي، السعرات، المسافة والرياضة",
            "3 تا 5 روز استفاده مداوم": "٣ إلى ٥ أيام استخدام مستمر",
            "5 تا 7 روز استفاده مداوم": "٥ إلى ٧ أيام استخدام مستمر",
            "7 تا 10 روز استفاده مداوم": "٧ إلى ١٠ أيام استخدام مستمر",
            "10 تا 15 روز": "١٠ إلى ١٥ يوماً",
            "15 تا 20 روز": "١٥ إلى ۲۰ يوماً",
            "شارژ مغناطیسی اختصاصی": "شاحن مغناطيسي خاص",
            "شارژر مگنتی": "شاحن مغناطيسي",
            "IP67 (مقاوم در برابر پاشش آب)": "IP67 (مقاوم لرذاذ الماء)",
            "IP68 (مقاوم تا عمق ۱.۵ متری)": "IP68 (مقاوم حتى عمق ١.٥ متر)",
            "آلیاژ روی + پلاستیک فشرده": "سبائك الزنك + بلاستيك مقوى",
            "سیلیکون طبّی ضد حساسیت": "سيليكون طبي مضاد للحساسية",
            "سیلیکون نرم باکیفیت": "سيليكون ناعم عالي الجودة",
            "0.96 اینچ TFT": "٠.٩٦ بوصة TFT",
            "1.47 اینچ AMOLED": "١.٤٧ بوصة AMOLED",
            "1.1 اینچ OLED": "١.١ بوصة OLED",
            "پایش عمومی خواب": "مراقبة النوم العامة",
            "پایش پیشرفته فازهای خواب": "مراقبة متقدمة لمراحل النوم",
            "پایش ۲۴ ساعته با هشدار": "مراقبة ۲۴/۷ مع تنبيهات",
            "پایش دوره‌ای": "مراقبة دورية",
            "ارزیابی غیرتهاجمی": "تقييم غیر جراحي",
            "پایش بنیادی چرخه": "تتبع الدورة الأساسي",
            "پایش کامل با پیش‌بینی": "تتبع كامل وتوقع الدورة",
            "هشدار افزایش استرس": "تنبيه ارتفاع التوتر",
            "تخمین پیوسته": "تقدير مستمر",
            "8 حالت ورزشی": "٨ أوضاع رياضية",
            "15 حالت ورزشی": "١٥ وضعاً رياضياً",
            "100+ حالت ورزشی": "+١٠٠ وضع رياضي",
            "مشکی، سرمه‌ای، صورتی": "أسود، كحلي، وردي",
            "مشکی، نقره‌ای، رزگلد": "أسود، فضي، ذهبي وردي",
            "بسیار بالا": "عالية جداً",
            "بالا": "عالية",
            "متوسط": "متوسط",
            "55 گرم": "٥٥ جرام",
            "45 گرم": "٤٥ جرام",
            "1.4 اینچ HD": "١.٤ بوصة HD",
            "1.3 اینچ IPS": "١.٣ بوصة IPS",
            "2 مگاپیکسل": "٢ ميجابكسل",
            "0.3 مگاپیکسل": "٠.٣ ميجابكسل",
            "4 هسته‌ای": "رباعي النواة",
            "دو هسته‌ای": "ثنائي النواة",
            "صورتی، آبی، مشکی": "وردی، أزرق، أسود",
            "آبی، قرمز": "أزرق، أحمر",
            "استیل": "صلب مقاوم للصدأ",
            "استیل ضد زنگ": "فولاذ مقاوم للصدأ",
            "استیل ضدزنگ": "فولاذ مقاوم للصدأ",
            "تیتانیوم": "تيتانيوم",
            "آلیاژ فلز با گرید ممتاز": "سبائك معدنية بدرجة ممتازة",
            "آلیاژ تیتانیوم": "سبائك التیتانیوم",
            "آلیاژ تیتانیوم درجه هوافضا (Titanium)": "سبائك تيتانيوم درجة الطيران",
            "آلیاژ تیتانیوم مقاوم و سبک (Titanium)": "سبائك تيتانيوم خفيفة ومتينة",
            "پلاستیک": "بلاستيك",
            "سرامیک": "سيراميك",
            "آلومینیوم": "ألومنيوم",
            "فولاد سبک": "صلب خفيف",
            "بافت فلزی کلاسیک": "ملمس معدني كلاسيكي",
            "مشکی براق (Full-light black)": "أسود لامع بالكامل",
            "مشکی": "أسود",
            "نقره‌ای": "فضي",
            "نقره ای": "فضي",
            "طلایی": "ذهبي",
            "رزگلد": "ذهبي وردي",
            "صورتی": "وردي",
            "آبی": "أزرق",
            "خاکستری": "رمادي",
            "طوسی": "رمادي",
            "سرمه‌ای": "كحلي",
            "زیتونی": "زيتي",
            "سبز": "أخضر",
            "قرمز": "أحمر",
            "مشکی (استاندارد)": "أسود (قياسي)",
            "ساده": "بسيط",
            "خیلی بالا": "عالية جداً",
            "گرید ممتاز": "درجة ممتازة",
            "بالا (تراشه‌های Goodix 3228T و Nordic)": "عالية (رقاقات Goodix و Nordic)",
            "بالا (دقت و پایش هوشمند)": "عالية (دقة ومتابعة ذكية)",
            "بسیار بالا (تخصصی بانوان)": "عالية جداً (متخصص للنساء)",
            "سطح ممتاز (سنسور ترانسمیسیون SpO2 با دقت ±2.7%)": "درجة ممتازة (دقة SpO2 ±۲.۷٪)",
            "معمولی": "عادي",
            "استاندارد": "قياسي",
            "پایین": "منخفض",
            "نامشخص (احتمالاً استاندارد)": "غیر محدد (قياسي)",
            "نامشخص": "غیر محدد",
            "6 گرم": "٦ جرام",
            "گرم 6": "٦ جرام",
            "5 گرم": "٥ جرام",
            "گرم 5": "٥ جرام",
            "4 گرم": "٤ جرام",
            "7 گرم": "٧ جرام",
            "8 گرم": "٨ جرام",
            "5.5 گرم": "٥٫٥ جرام",
            "36 گرم": "٣٦ جرام",
            "40 گرم": "٤٠ جرام",
            "42 گرم": "٤٢ جرام",
            "200 گرم": "٢٠٠ جرام",
            "3.4g": "٣٫٤ جرام",
            "4.2g": "٤٫٢ جرام",
            "2.5g": "٢٫٥ جرام",
            "3.1g": "٣٫١ جرام",
            "4.5g": "٤٫٥ جرام",
            "8g": "٨ جرام",
            "2 - 3g": "٢-٣ جرام",
            "7 روز": "٧ أيام",
            "روز 7": "٧ أيام",
            "10 روز": "١٠ أيام",
            "روز 10": "١٠ أيام",
            "3 روز": "٣ أيام",
            "4 روز": "٤ أيام",
            "5 روز": "٥ أيام",
            "6 روز": "٦ أيام",
            "9 روز": "٩ أيام",
            "3.5 روز": "٣٫٥ أيام",
            "4 تا 5 روز": "٤ إلى ٥ أيام",
            "4 تا 6 روز": "٤ إلى ٦ أيام",
            "7 تا 10 روز": "٧ إلى ١٠ أيام",
            "7+ روز": "٧+ أيام",
            "25+ روز": "٢٥+ يوماً",
            "30+ روز": "٣٠+ يوماً",
            "20+ روز": "٢٠+ يوماً",
            "فوق‌العاده سبک و کم‌حجم (طراحی ارگونومیک بدون صفحه نمایش)": "خفيف للغاية ومدمج (تصميم مريح بدون شاشة)",
            "آلیاژ روی و پلی‌کربنات فشرده (Zinc Alloy + PC)": "سبائك الزنك + بولي كربونات (PC)",
            "پارچه‌ای بافت‌دار تنفسی (Woven) / سیلیکونی ضدحساسیت": "قماش منسوج يتنفس / سيليكون مضاد للحساسية",
            "مشکی، طوسی، سرمه‌ای و رنگ‌های متنوع": "أسود، رمادي، كحلي وألوان متنوعة",
            "IP68 (مقاوم در برابر آب، تعریق و فعالیت‌های روزانه)": "IP68 (مقاوم للماء والعرق والأنشطة اليومية)",
            "دقت بالا مجهز به الکترودهای ECG و سنسور اپتیکال دوگانه PPG": "دقة عالية مجهزة بأقطاب ECG وسنسور PPG المزدوج",
            "130 mAh (لیتیوم پلیمری کم‌مصرف)": "١٣٠ مللي أمبير (ليثيوم بوليمر منخفض الاستهلاك)",
            "7 تا 14 روز (شارژدهی طولانی به دلیل حذف نمایشگر)": "٧ إلى ١٤ يوماً (عمر بطارية طويل)",
            "مگنتیک مغناطیسی (Magnetic Fast Charge)": "شحن مغناطيسي سريع",
            "بدون نمایشگر (Faceless / Screenless با نشانگر وضعیت LED)": "بدون شاشة (مؤشر حالات LED)",
            "پایش خودکار و پیشرفته مراحل خواب، کیفیت استراحت و الگوی تنفس": "مراقبة تلقائية ومتقدمة لمراحل النوم ونمط التنفس",
            "پایش ۲۴ ساعته سطح استرس و تحلیل تعادل عصبی با HRV": "مراقبة التوتر على مدار ۲٤ ساعة وتحليل HRV",
            "پشتیبانی کامل (پایش چرخه قاعدگی و سلامت بانوان)": "دعم كامل (مراقبة الدورة الشهرية وصحة المرأة)",
            "مودهای چندگانه ورزشی (Multi-Sport)، سنجش کالری و مسافت": "أوضاع رياضية متعددة وحساب السعرات والمسافة",
            "فوق‌العاده سبک و ارگونومیک (ابعاد 42×22×9.5 میلی‌متر)": "خفيف ومريح للغاية (أبعاد ٤٢×٢٢×٩٫٥ مم)",
            "پلی‌کربنات مقاوم و آلیاژ سبک (PC+ABS)": "بولي كربونات متين + سبائك خفيفة (PC+ABS)",
            "بافت‌دار کشسان و تنفسی (Woven) / نایلونی ضدحساسیت": "منسوج مرن يتنفس / نايلون مضاد للحساسية",
            "مشکی، زیتونی، رنگ‌های متنوع و جذاب": "أسود، زيتي وألوان متنوعة وجذابة",
            "IP68 (مقاوم در برابر آب و غوطه‌وری)": "IP68 (مقاوم للماء والغمر)",
            "پیشرفته با الگوریتم‌های هوش مصنوعی ریکاوری و سنسورهای چندگانه": "متقدم مع خوارزميات التعافي بالذكاء الاصطناعي",
            "95 mAh (لیتیوم پلیمری کم‌مصرف)": "٩٥ مللي أمبير (ليثيوم بوليمر منخفض الاستهلاك)",
            "مگنتیک فست‌شارژ (Magnetic Fast Charge)": "شحن مغناطيسي سريع",
            "بدون نمایشگر (Screenless - تمرکز کامل بر ریکاوری بدون حواس‌پرتی)": "بدون شاشة (تركيز كامل على التعافي)",
            "BLE 5.0 (برد تا ۱۰ متر)": "BLE 5.0 (مدى حتى ١٠ أمتار)",
            "پایش پیشرفته فازهای خواب (REM/عمیق/سبک)، الگوی تنفس و نمره خواب": "مراقبة متقدمة لمراحل النوم ونمط التنفس",
            "ارزیابی استرس و پایش حالات روحی مبتنی بر هوش مصنوعی (AI Mood)": "تقييم المزاج والتوتر بالذكاء الاصطناعي",
            "پشتیبانی کامل (پایش چرخه قاعدگی و پیش‌بینی تخمک‌گذاری)": "دعم كامل (مراقبة الدورة الشهرية والتنبؤ بالتبييض)",
            "پایش بار تمرینی (Strain)، ریکاوری هوشمند و مربی هوش مصنوعی": "تتبع جهد التدريب والتعافي الذكي",
            "فوق‌العاده سبک (ابعاد 25.5×9.3×4.35 میلی‌متر)": "خفيف للغاية (أبعاد ۲٥٫٥×٩٫۳×٤٫۳٥ مم)",
            "بافت‌دار تنفسی (Woven) / سیلیکونی ضدحساسیت": "منسوج يتنفس / سيليكون مضاد للحساسية",
            "مشکی، نقره‌ای، رنگ‌های متنوع": "أسود، فضي وألوان متنوعة",
            "3ATM (مقاوم تا عمق ۳۰ متری)": "3ATM (مقاوم حتى عمق ۳۰ متراً)",
            "پیشرفته با هوش مصنوعی و سنسورهای اپتیکال چندگانه": "متقدم بالذكاء الاصطناعي والمستشعرات البصرية",
            "23 mAh (بهینه‌سازی شده با مصرف فوق‌العاده کم)": "٢٣ مللي أمبير (استهلاك منخفض للغاية)",
            "مگنتیک فست‌شارژ (کمتر از ۱.۵ ساعت)": "شحن مغناطيسي سريع (أقل من ١٫٥ ساعة)",
            "بدون نمایشگر (طراحی مینیمال و ارگونومیک)": "بدون شاشة (تصميم مريح وبسيط)",
            "ارزیابی غیرتهاجمی روند انرژی و متابولیسم با هوش مصنوعی (BGEM)": "تقييم مسار الطاقة والتمثيل الغذائي بدون وخز بالذكاء الاصطناعي",
            "پایش پیشرفته فازهای خواب (REM/عمیق) و الگوی تنفس": "مراقبة متقدمة لمراحل النوم ونمط التنفس",
            "پشتیبانی کامل (پایش چرخه و سلامت بانوان)": "دعم كامل (مراقبة الدورة وصحة المرأة)",
            "پایش ۲۴ ساعته فعالیت، شدت METS و بار ورزشی": "مراقبة النشاط على مدار ۲٤ ساعة وشدة METS",
            "پلی‌کربنات (PC) ": "بولي كربونات (PC)",
            "پارچه‌ای (Woven) / سیلیکونی": "قماش منسوج / سيليكون",
            "بالا (تراشه ECG با فرکانس 512Hz)": "عالية (رقاقة ECG بتردد ۵۱۲ هرتز)",
            "180 mAh": "١٨٠ مللي أمبير",
            "7 تا 15 روز": "٧ إلى ١٥ يوماً",
            "مگنتیک (Magnetic)": "مغناطيسي",
            "بدون نمایشگر (LED Indicator)": "بدون شاشة (مؤشر LED)",
            "بندهای بافت‌دار (Woven)": "أحزمة منسوجة",
            "رنگ‌های متنوع (Vibrant Bands)": "ألوان متنوعة وحيوية",
            "بیشتر از 15 روز": "أكثر من ١٥ يوماً",
            "58 mAh + 210 mAh dock": "٥٨ + ٢١٠ مللي أمبير مع القاعدة",
            "Magnetic Charging Dock": "قاعدة شحن مغناطيسية",
            "ABS+PC": "سبائك ABS+PC",
            "Silicone": "سيليكون",
            "Vibrant Colors": "ألوان جذابة ومتنوعة",
            "حدود ۲۵ گرم": "نحو ۲٥ جراماً",
            "بند سیلیکونی": "حزام سيليكون",
            "دیجیتالی": "رقمي",
            "دارای نمایشگر": "مع شاشة",
            "مشکی، آبی، قرمز، سبز": "أسود، أزرق، أحمر، أخضر",
            "معمولی (مناسب پایش روزمره و تناسب اندام)": "عادي (مناسب للمراقبة اليومية)",
            "۵ تا ۷ روز (باتری 130mAh)": "٥ إلى ٧ أيام (بطارية ١٣٠ مللي أمبير)",
            "100 mAh": "١٠٠ مللي أمبير",
            "Hospital-grade PPG": "PPG بمستوى المستشفيات",
            "Swimming/Running/Cycling/Yoga": "السباحة / الجري / ركوب الدراجات / اليوغا",
            "Multiple Colors": "ألوان متعددة",
            "150 mAh": "١٥٠ مللي أمبير",
            "20-30 روز": "٢٠ إلى ٣٠ يوماً",
            "45-60 روز": "٤٥ إلى ٦٠ يوماً",
            "Silicone/Nylon": "سيليكون / نايلون",
            "VC30F-S": "VC30F-S",
            "Multiple": "متعدد",
            "55 mAh": "٥٥ مللي أمبير",
            "Zinc Alloy": "سبائك الزنك",
            "Steel/Silicone": "صلب / سيليكون",
            "170+": "+١٧٠",
            "Magnetic USB": "شاحن USB مغناطيسي",
            "50+": "+٥٠",
            "Black/Blue/Pink": "أسود / أزرق / وردي"
        }
    },
    "tr": {
        "featuresAndSpecs": "Özellikler ve Detaylar",
        "viewSpecs": "Özellikleri Gör",
        "hardwareAndDesign": "Donanım ve Tasarım",
        "sensorsAndHealth": "Sensörler ve Sağlık Takibi",
        "smartCapabilities": "Akıllı Özellikler",
        "otherFeatures": "Diğer Özellikler",
        "viewAllSpecs": "Tüm Özellikleri Gör",
        "showLess": "Daha Az Göster",
        "selectCategoryHelp": "Farklı serileri karşılaştırmak için bir kategori seçin",
        "fullProductSpecs": "Tüm Teknik Özellikler ve Detaylar",
        "models": "Modeller:",
        "medical": "Medikal Düzey",
        "economic": "Ekonomik",
        "standard": "Standart",
        "advanced": "Gelişmiş",
        "women": "Kadın Sağlığı",
        "kidwatch": "Çocuk Saati",
        "tracker": "Takip Cihazı",
        "all": "Tümü",
        "allTrackers": "Tüm Takip Cihazları",
        "yes": "Var",
        "active": "Aktif",
        "close": "Kapat",
        "categories": {
            "all": "Tümü",
            "medical": "Medikal Düzey",
            "standard": "Standart",
            "economic": "Ekonomik",
            "advanced": "Gelişmiş",
            "women": "Kadın Sağlığı",
            "kidwatch": "Çocuk Saati",
            "tracker": "Takip Cihazı",
            "screenless-band": "Ekransız Akıllı Bileklik",
            "fitness-band": "Fitness Bilekliği",
            "smartband": "Akıllı Bileklik"
        },
        "features": {
            "وزن": "Ağırlık",
            "جنس بدنه": "Gövde Malzemesi",
            "رنگ‌بندی": "Renk Seçenekleri",
            "گواهی ضد آب": "Su Geçirmezlik",
            "درجه دقت حسگرها": "Sensör Hassasiyeti",
            "عمر باتری": "Pil Ömrü",
            "شارژ بی‌سیم": "Kablosuz Şarj",
            "پایش سلامت پیوسته و ۲۴ ساعته": "7/24 Kesintisiz Sağlık Takibi",
            "ضربان قلب": "Kalp Atış Hızı",
            "تغییرات HRV": "HRV Değişkenliği",
            "سطح اکسیژن خون (SpO2)": "Kandaki Oksijen (SpO2)",
            "ECG (نوار قلب)": "EKG (Elektrokardiyogram)",
            "VO2max": "VO2max Dayanıklılık",
            "روند انرژی و متابولیسم": "Enerji ve Metabolizma Eğilimi",
            "پایش خواب": "Uyku Takibi",
            "نرخ تنفس": "Solunum Hızı",
            "دمای پوست": "Cilt Sıcaklığı",
            "دمای بدن": "Vücut Sıcaklığı",
            "قدم‌شمار": "Adımsayar",
            "حالت ورزشی": "Spor Modu",
            "تعداد حالت‌های ورزشی": "Spor Modu Sayısı",
            "سطح استرس": "Stres Seviyesi",
            "ژست‌های حرکتی": "Hareket Jestleri",
            "تماس اضطراری": "Acil SOS Araması",
            "API توسعه‌دهنده": "Geliştirici API",
            "اشتراک‌گذاری سلامت با خانواده و اعضا": "Aile Sağlık Paylaşımı",
            "جنس بند": "Kordon Malzemesi",
            "نمایشگر": "Ekran",
            "ظرفیت باتری (mAh)": "Pil Kapasitesi",
            "زمان آماده‌باش": "Bekleme Süresi",
            "نوع شارژ": "Şarj Tipi",
            "بلوتوث": "Bluetooth",
            "به‌روزرسانی OTA": "OTA Güncellemesi",
            "NFC": "NFC",
            "بانوان": "Kadın Sağlığı",
            "مود ورزشی": "Antrenman Modu",
            "ردیابی موقعیت": "GPS / Konum Takibi",
            "پایش گردش خون": "Dolaşım Takibi",
            "ارتباط سلولی (Comm.)": "Hücresel Bağlantı",
            "GPS": "GPS",
            "حافظه": "RAM Bellek",
            "دیسک": "Dahili Depolama",
            "اندازه نمایشگر": "Ekran Boyutu",
            "جنس نمایشگر": "Ekran Teknolojisi",
            "دوربین": "Kamera",
            "تعداد هسته‌های پردازنده": "İşlemci Çekirdeği",
            "قابلیت تماس صوتی": "Sesli Arama",
            "دکمه اضطراری (SoS Button)": "SOS Butonu"
        },
        "featureDescriptions": {
            "وزن دستگاه برای استفاده روزانه": "Günlük kullanım için cihaz ağırlığı",
            "متریال ضدحساسیت و مقاوم": "Anti-alerjik ve dayanıklı malzemeler",
            "رنگ‌های متنوع و قابل انتخاب": "Çeşitli renk seçenekleri",
            "مناسب برای شستشو یا باران": "Yıkama ve yağmur için uygun",
            "میزان دقت در پایش سلامت": "Sağlık takibinde hassasiyet seviyesi",
            "مدت زمان نگهداری شارژ": "Pil kullanım süresi",
            "مدت زمان نگهداری شارژ در استفاده عادی": "Normal kullanımda pil ömrü",
            "شارژ بدون نیاز به کابل": "Kablosuz şarj imkanı",
            "رصد دائمی علائم حیاتی در طول شبانه‌روز": "7/24 kesintisiz yaşam bulguları takibi",
            "پایش مداوم سلامت قلب": "Sürekli kalp sağlığı takibi",
            "تحلیل استرس و ریکاوری": "Stres ve iyileşme analizi",
            "بررسی سطح اکسیژن در خون": "Kandaki oksijen seviyesi takibi",
            "تشخیص بی‌نظمی‌های قلب": "Kalp ritim bozukluğu tespiti",
            "سنجش توان هوازی بدن": "Aerobik kapasite değerlendirmesi",
            "پشتیبانی از پایش گلوکز": "Kan şekeri riski takip desteği",
            "تحلیل کیفیت خواب شبانه": "Gece uyku kalitesi analizi",
            "تعداد تنفس در دقیقه": "Dakikadaki solunum sayısı",
            "پایش تب و تغییرات دما": "Ateş ve cilt sıcaklığı takibi",
            "شمارش قدم‌های روزانه": "Günlük adım sayımı",
            "پایش فعالیت‌های ورزشی و تناسب اندام": "Spor ve fitness aktivite takibi",
            "ارزیابی تنش روزانه": "Günlük stres seviyesi değerlendirmesi",
            "کنترل با ضربه یا حرکت دست": "Dokunma ve jest kontrolü",
            "ارسال هشدار در شرایط خطر": "Acil durum SOS uyarısı",
            "دسترسی به داده برای برنامه‌نویس": "Geliştirici API erişimi",
            "امکان ارسال وضعیت سلامت به عزیزان": "Aile sağlık verisi paylaşımı",
            "ظرفیت باتری به میلی‌آمپر ساعت برای مدت زمان استفاده مداوم": "mAh cinsinden pil kapasitesi",
            "مدت زمان نگهداری شارژ در حالت آماده‌باش": "Bekleme modunda pil ömrü",
            "روش اتصال شارژر به دستگاه": "Şarj cihazı bağlantı türü",
            "استاندارد مقاومت در برابر نفوذ آب": "Su geçirmezlik standardı",
            "نوع متریال بند دستگاه": "Kordon malzeme türü",
            "نوع و اندازه صفحه نمایش": "Ekran türü ve boyutu",
            "بررسی تغییرات زمانی بین ضربان‌های قلب": "Kalp atış hızı değişkenliği takibi",
            "پایش و ارزیابی غیرتهاجمی روند انرژی": "Girişimsel olmayan enerji eğilimi takibi",
            "پایش چرخه قاعدگی، تخمک‌گذاری و سلامت بانوان": "Adet döngüsü ve yumurtlama takibi",
            "پایش گردش خون": "Dolaşım takibi",
            "شمار انواع فعالیت‌های ورزشی قابل پایش": "Takip edilebilir spor modu sayısı",
            "سطح دقت سنسورهای پایش سلامت برای اندازه‌گیری دقیق‌تر داده‌ها": "Sağlık sensörlerinin hassasiyet seviyesi",
            "مکان‌یابی دقیق با استفاده از سیستم موقعیت‌یاب جهانی": "GPS ile hassas konum belirleme",
            "دارای استاندارد مقاومت در برابر نفوذ آب برای استفاده در شرایط مرطوب": "Islak ortamlar için su geçirmezlik standardı",
            "حجم حافظه داخلی برای ذخیره‌سازی اطلاعات و داده‌ها": "Dahili depolama kapasitesi",
            "واحد ذخیره‌سازی قابل ارتقاء یا تعویض داخل دستگاه": "Depolama sürücü modülü",
            "قطر یا سطح نمایشگر برای مشاهده راحت‌تر اطلاعات": "Ekran boyutu ve görüş alanı",
            "نوع متریال به کار رفته در صفحه نمایش برای مقاومت و وضوح بهتر": "Ekran malzeme teknolojisi",
            "مشخصات و رزولوشن دوربین برای ثبت تصاویر و تماس‌های ویدیویی": "Kamera çözünürlüğü ve görüntülü arama",
            "شماره هسته‌های پردازشی برای عملکرد سریع‌تر و روان‌تر": "İşlemci çekirdek sayısı",
            "پایش لحظه‌ای میزان ضربان قلب و نمایش روند سلامت قلب": "Anlık kalp atış hızı takibi",
            "انتخاب بین رنگ‌های مختلف بدنه برای سلیقه‌های گوناگون": "Gövde rengi seçenekleri",
            "پشتیبانی از شبکه‌های ارتباطی مانند 4G برای اتصال و ارتباط بی‌وقفه": "4G hücresel ağ desteği",
            "مکان‌یابی لحظه‌ای با دقت بالا برای ردیابی موقعیت": "Yüksek hassasiyetli anlık konum takibi",
            "استاندارد مقاومت در برابر نفوذ آب برای استفاده ایمن در شرایط مرطوب": "Güvenli kullanım için su geçirmezlik standardı",
            "میزان ظرفیت باتری برای تعیین طول عمر شارژ و دوام استفاده": "Kullanım süresi için pil kapasitesi",
            "وزن دستگاه برای راحتی در پوشیدن مداوم بدون احساس سنگینی": "Konforlu kullanım için cihaz ağırlığı",
            "امکان برقراری تماس صوتی میان دستگاه و سرپرست برای برقراری ارتباط فوری": "Sesli arama özelliği",
            "ارسال سیگنال هشدار به مخاطب‌های از پیش تعریف‌شده در مواقع اضطراری": "Acil durum SOS uyarı butonu",
            "امکان ثبت تصویر و تماس ویدئویی برای بررسی تصویری محیط یا کودک": "Fotoğraf ve görüntülü arama imkanı",
            "تنوع رنگ‌های قابل انتخاب برای سلیقه‌ها و اولویت‌های مختلف": "Çeşitli renk seçenekleri ve tercihler"
        },
        "featureValues": {
            "127": "127",
            "فوق‌العاده سبک حدود ۲ تا ۳ گرم (ضخامت 2.2mm، پهنا 8.0mm)": "Ultra hafif ~2-3g (Kalınlık 2.2mm, Genişlik 8.0mm)",
            "فوق‌العاده باریک (ضخامت 2.2mm، پهنا 8.0mm)": "Ultra ince (Kalınlık 2.2mm, Genişlik 8.0mm)",
            "فوق‌العاده سبک و ارگونومیک (پهنا 8.0 میلی‌متر)": "Ultra hafif ve ergonomik (Genişlik 8.0mm)",
            "سبک و مقاوم": "Hafif ve dayanıklı",
            "طراحی ارگونومیک": "Ergonomik tasarım",
            "آلیاژ تیتانیوم مقاوم درجه یک (Titanium)": "Birinci Sınıf Titanyum Alaşımı",
            "استیل ضد زنگ ۳۱۶L": "316L Paslanmaz Çelik",
            "سرامیک پیشرفته زیرکونیا / تیتانیوم (Ceramic/Titanium)": "Gelişmiş Zirkonya Seramik / Titanyum",
            "رزگلد، نقره‌ای، مشکی، طلایی": "Roz Altın, Gümüş, Siyah, Altın",
            "مشکی براق سرامیکی، نقره‌ای، طلایی": "Parlak Seramik Siyah, Gümüş, Altın",
            "مشکی، نقره‌ای، خاکستری، طلایی": "Siyah, Gümüş, Gri, Altın",
            "مشکی، نقره‌ای، طلایی": "Siyah, Gümüş, Altın",
            "5ATM (مقاوم تا عمق ۵۰ متری - مناسب شنا و استفاده روزمره)": "5ATM (50m Su Geçirmez - Yüzme ve Günlük)",
            "IP68 / 5ATM (مقاوم در برابر آب و گرد و غبار)": "IP68 / 5ATM (Su ve Toza Dayanıklı)",
            "بسیار بالا مجهز به سنسور حرارتی تخصصی دمای پایه بدن (BBT) و ماژول اپتیکال PPG": "Çok Yüksek (BBT Termal ve PPG Optik Sensör)",
            "بالا (سنسور PPG اپتیکال نسل جدید)": "Yüksek (Yeni Nesil PPG Optik Sensör)",
            "استاندارد و دقیق": "Standart ve Hassas",
            "7 تا 10 روز (شارژ سریع در کمتر از ۲ ساعت)": "7-10 Gün (2 saatten kısa sürede hızlı şarj)",
            "5 تا 7 روز": "5-7 Gün",
            "3 تا 5 روز": "3-5 Gün",
            "پایش مداوم و شبانه‌روزی اکسیژن خون (SpO2)": "7/24 Kesintisiz SpO2 Takibi",
            "ارزیابی غیرتهاجمی روند انرژی": "Girişimsel Olmayan Enerji Eğilimi",
            "پایش تخصصی فازهای خواب (Light/Deep/REM)، نمره خواب، Fuel Score و کیفیت استراحت": "Gelişmiş Uyku Aşamaları (Hafif/Derin/REM) ve Uyku Puanı",
            "پایش پیوسته دمای پوست و دمای پایه بدن در خواب (BBT Tracking)": "Sürekli Cilt Sıcaklığı ve BBT Takibi",
            "پایش ۲۴ ساعته سطح استرس، شاخص VitalAge و آمادگی ریکاوری": "24/7 Stres Takibi, VitalAge İndeksi ve İyileşme",
            "تخصصی و پیشرفته (پایش دمای شبانه BBT، پیش‌بینی دقیق چرخه قاعدگی، زمان تخمک‌گذاری و بارداری)": "Gelişmiş Kadın Sağlığı (Gece BBT, Adet ve Yumurtlama Tahmini)",
            "پایش فعالیت روزانه، کالری مصرفی، مسافت و مودهای ورزشی چندگانه": "Günlük Aktivite, Kalori, Mesafe ve Çoklu Spor Modları",
            "3 تا 5 روز استفاده مداوم": "3-5 Gün Kesintisiz Kullanım",
            "5 تا 7 روز استفاده مداوم": "5-7 Gün Kesintisiz Kullanım",
            "7 تا 10 روز استفاده مداوم": "7-10 Gün Kesintisiz Kullanım",
            "10 تا 15 روز": "10-15 Gün",
            "15 تا 20 روز": "15-20 Gün",
            "شارژ مغناطیسی اختصاصی": "Özel Manyetik Şarj",
            "شارژر مگنتی": "Manyetik Şarj Cihazı",
            "IP67 (مقاوم در برابر پاشش آب)": "IP67 (Su Sıçramasına Dayanıklı)",
            "IP68 (مقاوم تا عمق ۱.۵ متری)": "IP68 (1.5m Derinliğe Kadar)",
            "آلیاژ روی + پلاستیک فشرده": "Çinko Alaşımı + Sert Plastik",
            "سیلیکون طبّی ضد حساسیت": "Tıbbi Sınıf Anti-Alerjik Silikon",
            "سیلیکون نرم باکیفیت": "Yüksek Kaliteli Yumuşak Silikon",
            "0.96 اینچ TFT": "0.96 inç TFT",
            "1.47 اینچ AMOLED": "1.47 inç AMOLED",
            "1.1 اینچ OLED": "1.1 inç OLED",
            "پایش عمومی خواب": "Genel Uyku Takibi",
            "پایش پیشرفته فازهای خواب": "Gelişmiş Uyku Aşamaları Takibi",
            "پایش ۲۴ ساعته با هشدار": "Uyarı Sistemli 7/24 Takip",
            "پایش دوره‌ای": "Periyodik Takip",
            "ارزیابی غیرتهاجمی": "Girişimsel Olmayan Değerlendirme",
            "پایش بنیادی چرخه": "Temel Döngü Takibi",
            "پایش کامل با پیش‌بینی": "Tahminli Tam Döngü Takibi",
            "هشدار افزایش استرس": "Yüksek Stres Uyarısı",
            "تخمین پیوسته": "Sürekli Tahmin",
            "8 حالت ورزشی": "8 Spor Modu",
            "15 حالت ورزشی": "15 Spor Modu",
            "100+ حالت ورزشی": "100+ Spor Modu",
            "مشکی، سرمه‌ای، صورتی": "Siyah, Lacivert, Pembe",
            "مشکی، نقره‌ای، رزگلد": "Siyah, Gümüş, Roz Altın",
            "بسیار بالا": "Çok Yüksek",
            "بالا": "Yüksek",
            "متوسط": "Orta",
            "55 گرم": "55 gram",
            "45 گرم": "45 gram",
            "1.4 اینچ HD": "1.4 inç HD",
            "1.3 اینچ IPS": "1.3 inç IPS",
            "2 مگاپیکسل": "2 MP",
            "0.3 مگاپیکسل": "0.3 MP",
            "4 هسته‌ای": "4 Çekirdekli",
            "دو هسته‌ای": "Çift Çekirdekli",
            "صورتی، آبی، مشکی": "Pembe, Mavi, Siyah",
            "آبی، قرمز": "Mavi, Kırmızı",
            "استیل": "Paslanmaz Çelik",
            "استیل ضد زنگ": "Paslanmaz Çelik",
            "استیل ضدزنگ": "Paslanmaz Çelik",
            "تیتانیوم": "Titanyum",
            "آلیاژ فلز با گرید ممتاز": "Üstün Sınıf Metal Alaşım",
            "آلیاژ تیتانیوم": "Titanyum Alaşımı",
            "آلیاژ تیتانیوم درجه هوافضا (Titanium)": "Havacılık Sınıfı Titanyum",
            "آلیاژ تیتانیوم مقاوم و سبک (Titanium)": "Hafif Titanyum Alaşımı",
            "پلاستیک": "Plastik",
            "سرامیک": "Seramik",
            "آلومینیوم": "Alüminyum",
            "فولاد سبک": "Hafif Çelik",
            "بافت فلزی کلاسیک": "Klasik Metalik Doku",
            "مشکی براق (Full-light black)": "Parlak Siyah",
            "مشکی": "Siyah",
            "نقره‌ای": "Gümüş",
            "نقره ای": "Gümüş",
            "طلایی": "Altın",
            "رزگلد": "Roz Altın",
            "صورتی": "Pembe",
            "آبی": "Mavi",
            "خاکستری": "Gri",
            "طوسی": "Gri",
            "سرمه‌ای": "Lacivert",
            "زیتونی": "Zeytin Yeşili",
            "سبز": "Yeşil",
            "قرمز": "Kırmızı",
            "مشکی (استاندارد)": "Siyah (Standart)",
            "ساده": "Sade",
            "خیلی بالا": "Çok Yüksek",
            "گرید ممتاز": "Üstün Düzey",
            "بالا (تراشه‌های Goodix 3228T و Nordic)": "Yüksek (Goodix ve Nordic)",
            "بالا (دقت و پایش هوشمند)": "Yüksek (Akıllı Hassasiyet)",
            "بسیار بالا (تخصصی بانوان)": "Çok Yüksek (Kadın Sağlığı Özel)",
            "سطح ممتاز (سنسور ترانسمیسیون SpO2 با دقت ±2.7%)": "Üstün Düzey (SpO2 ±%2.7)",
            "معمولی": "Standart",
            "استاندارد": "Standart",
            "پایین": "Temel",
            "نامشخص (احتمالاً استاندارد)": "Belirtilmemiş (Standart)",
            "نامشخص": "Belirtilmemiş",
            "6 گرم": "6 gram",
            "گرم 6": "6 gram",
            "5 گرم": "5 gram",
            "گرم 5": "5 gram",
            "4 گرم": "4 gram",
            "7 گرم": "7 gram",
            "8 گرم": "8 gram",
            "5.5 گرم": "5.5 gram",
            "36 گرم": "36 gram",
            "40 گرم": "40 gram",
            "42 گرم": "42 gram",
            "200 گرم": "200 gram",
            "3.4g": "3.4g",
            "4.2g": "4.2g",
            "2.5g": "2.5g",
            "3.1g": "3.1g",
            "4.5g": "4.5g",
            "8g": "8g",
            "2 - 3g": "2-3g",
            "7 روز": "7 Gün",
            "روز 7": "7 Gün",
            "10 روز": "10 Gün",
            "روز 10": "10 Gün",
            "3 روز": "3 Gün",
            "4 روز": "4 Gün",
            "5 روز": "5 Gün",
            "6 روز": "6 Gün",
            "9 روز": "9 Gün",
            "3.5 روز": "3.5 Gün",
            "4 تا 5 روز": "4-5 Gün",
            "4 تا 6 روز": "4-6 Gün",
            "7 تا 10 روز": "7-10 Gün",
            "7+ روز": "7+ Gün",
            "25+ روز": "25+ Gün",
            "30+ روز": "30+ Gün",
            "20+ روز": "20+ Gün",
            "فوق‌العاده سبک و کم‌حجم (طراحی ارگونومیک بدون صفحه نمایش)": "Ultra Hafif ve Kompakt (Ekransız Ergonomik Tasarım)",
            "آلیاژ روی و پلی‌کربنات فشرده (Zinc Alloy + PC)": "Çinko Alaşımı + Polikarbonat (PC)",
            "پارچه‌ای بافت‌دار تنفسی (Woven) / سیلیکونی ضدحساسیت": "Nefes Alabilen Dokuma Kumaş / Anti-Alerjik Silikon",
            "مشکی، طوسی، سرمه‌ای و رنگ‌های متنوع": "Siyah, Gri, Lacivert ve Çeşitli Renkler",
            "IP68 (مقاوم در برابر آب، تعریق و فعالیت‌های روزانه)": "IP68 (Su, Ter ve Günlük Aktivitelere Dayanıklı)",
            "دقت بالا مجهز به الکترودهای ECG و سنسور اپتیکال دوگانه PPG": "Yüksek Hassasiyet (EKG Elektrotları ve Çift PPG Sensör)",
            "130 mAh (لیتیوم پلیمری کم‌مصرف)": "130 mAh Düşük Güçlü Lityum Polimer",
            "7 تا 14 روز (شارژدهی طولانی به دلیل حذف نمایشگر)": "7-14 Gün (Ekransız Tasarım Sayesinde Uzun Pil Ömrü)",
            "مگنتیک مغناطیسی (Magnetic Fast Charge)": "Hızlı Manyetik Şarj",
            "بدون نمایشگر (Faceless / Screenless با نشانگر وضعیت LED)": "Ekransız (LED Durum Göstergesi)",
            "پایش خودکار و پیشرفته مراحل خواب، کیفیت استراحت و الگوی تنفس": "Otomatik ve Gelişmiş Uyku Aşamaları, Kalite ve Solunum Düzeni",
            "پایش ۲۴ ساعته سطح استرس و تحلیل تعادل عصبی با HRV": "24/7 Stres Seviyesi ve HRV Sinir Denge Analizi",
            "پشتیبانی کامل (پایش چرخه قاعدگی و سلامت بانوان)": "Tam Destek (Adet Döngüsü ve Kadın Sağlığı)",
            "مودهای چندگانه ورزشی (Multi-Sport)، سنجش کالری و مسافت": "Çoklu Spor Modları, Kalori ve Mesafe",
            "فوق‌العاده سبک و ارگونومیک (ابعاد 42×22×9.5 میلی‌متر)": "Ultra Hafif ve Ergonomik (42×22×9.5mm)",
            "پلی‌کربنات مقاوم و آلیاژ سبک (PC+ABS)": "Dayanıklı Polikarbonat ve Hafif Alaşım (PC+ABS)",
            "بافت‌دار کشسان و تنفسی (Woven) / نایلونی ضدحساسیت": "Esnek Dokuma / Anti-Alerjik Naylon",
            "مشکی، زیتونی، رنگ‌های متنوع و جذاب": "Siyah, Zeytin Yeşili ve Canlı Renkler",
            "IP68 (مقاوم در برابر آب و غوطه‌وری)": "IP68 (Su Geçirmez ve Dalışa Dayanıklı)",
            "پیشرفته با الگوریتم‌های هوش مصنوعی ریکاوری و سنسورهای چندگانه": "Gelişmiş Yapay Zeka İyileşme Algoritmaları",
            "95 mAh (لیتیوم پلیمری کم‌مصرف)": "95 mAh Düşük Güçlü Lityum Polimer",
            "مگنتیک فست‌شارژ (Magnetic Fast Charge)": "Hızlı Manyetik Şarj",
            "بدون نمایشگر (Screenless - تمرکز کامل بر ریکاوری بدون حواس‌پرتی)": "Ekransız (Odaklanmış İyileşme)",
            "BLE 5.0 (برد تا ۱۰ متر)": "BLE 5.0 (10 metreye kadar menzil)",
            "پایش پیشرفته فازهای خواب (REM/عمیق/سبک)، الگوی تنفس و نمره خواب": "Gelişmiş Uyku Aşamaları, Solunum ve Uyku Puanı",
            "ارزیابی استرس و پایش حالات روحی مبتنی بر هوش مصنوعی (AI Mood)": "Yapay Zeka Destekli Ruh Hali ve Stres Analizi",
            "پشتیبانی کامل (پایش چرخه قاعدگی و پیش‌بینی تخمک‌گذاری)": "Tam Destek (Adet Döngüsü ve Yumurtlama Tahmini)",
            "پایش بار تمرینی (Strain)، ریکاوری هوشمند و مربی هوش مصنوعی": "Egzersiz Yükü, Akıllı İyileşme ve Yapay Zeka Koçu",
            "فوق‌العاده سبک (ابعاد 25.5×9.3×4.35 میلی‌متر)": "Ultra Hafif (25.5×9.3×4.35mm)",
            "بافت‌دار تنفسی (Woven) / سیلیکونی ضدحساسیت": "Nefes Alabilen Dokuma / Anti-Alerjik Silikon",
            "مشکی، نقره‌ای، رنگ‌های متنوع": "Siyah, Gümüş ve Çeşitli Renkler",
            "3ATM (مقاوم تا عمق ۳۰ متری)": "3ATM (30m Su Geçirmez)",
            "پیشرفته با هوش مصنوعی و سنسورهای اپتیکال چندگانه": "Gelişmiş Yapay Zeka ve Çoklu Optik Sensörler",
            "23 mAh (بهینه‌سازی شده با مصرف فوق‌العاده کم)": "23 mAh Ultra Düşük Güç Tüketimi",
            "مگنتیک فست‌شارژ (کمتر از ۱.۵ ساعت)": "Hızlı Manyetik Şarj (1.5 saatten az)",
            "بدون نمایشگر (طراحی مینیمال و ارگونومیک)": "Ekransız (Minimalist Ergonomik Tasarım)",
            "ارزیابی غیرتهاجمی روند انرژی و متابولیسم با هوش مصنوعی (BGEM)": "Girişimsel Olmayan Enerji ve Metabolizma Eğilimi (BGEM)",
            "پایش پیشرفته فازهای خواب (REM/عمیق) و الگوی تنفس": "Gelişmiş Uyku Aşamaları ve Solunum Düzeni",
            "پشتیبانی کامل (پایش چرخه و سلامت بانوان)": "Tam Destek (Döngü ve Kadın Sağlığı)",
            "پایش ۲۴ ساعته فعالیت، شدت METS و بار ورزشی": "7/24 Aktivite Takibi, METS Şiddeti ve Egzersiz Yükü",
            "پلی‌کربنات (PC) ": "Polikarbonat (PC)",
            "پارچه‌ای (Woven) / سیلیکونی": "Dokuma Kumaş / Silikon",
            "بالا (تراشه ECG با فرکانس 512Hz)": "Yüksek (512Hz EKG Çipi)",
            "180 mAh": "180 mAh",
            "7 تا 15 روز": "7-15 Gün",
            "مگنتیک (Magnetic)": "Manyetik",
            "بدون نمایشگر (LED Indicator)": "Ekransız (LED Göstergesi)",
            "بندهای بافت‌دار (Woven)": "Dokuma Kordonlar",
            "رنگ‌های متنوع (Vibrant Bands)": "Canlı Renkli Kordonlar",
            "بیشتر از 15 روز": "15+ Gün",
            "58 mAh + 210 mAh dock": "58 mAh + 210 mAh şarj istasyonu",
            "Magnetic Charging Dock": "Manyetik Şarj İstasyonu",
            "ABS+PC": "ABS+PC",
            "Silicone": "Silikon",
            "Vibrant Colors": "Canlı Renkler",
            "حدود ۲۵ گرم": "Yaklaşık 25g",
            "Bند سیلیکونی": "Silikon Kordon",
            "بند سیلیکونی": "Silikon Kordon",
            "دیجیتالی": "Dijital",
            "دارای نمایشگر": "Ekranlı",
            "مشکی، آبی، قرمز، سبز": "Siyah, Mavi, Kırmızı, Yeşil",
            "معمولی (مناسب پایش روزمره و تناسب اندام)": "Standart (Günlük Fitness Takibine Uygun)",
            "۵ تا ۷ روز (باتری 130mAh)": "5-7 Gün (130mAh Pil)",
            "100 mAh": "100 mAh",
            "Hospital-grade PPG": "Hastane Tipi PPG",
            "Swimming/Running/Cycling/Yoga": "Yüzme / Koşu / Bisiklet / Yoga",
            "Multiple Colors": "Çeşitli Renkler",
            "150 mAh": "150 mAh",
            "20-30 روز": "20-30 Gün",
            "45-60 روز": "45-60 Gün",
            "Silicone/Nylon": "Silikon / Naylon",
            "VC30F-S": "VC30F-S",
            "Multiple": "Çeşitli",
            "55 mAh": "55 mAh",
            "Zinc Alloy": "Çinko Alaşımı",
            "Steel/Silicone": "Çelik / Silikon",
            "170+": "170+",
            "Magnetic USB": "Manyetik USB",
            "50+": "50+",
            "Black/Blue/Pink": "Siyah / Mavi / Pembe"
        }
    }
};
